import React from 'react';
import { formatDetailedTime, formatDate, getBrandingText } from '../templateUtils';

const PaperTemplate = ({
  language = 'zh',
  calculatedDays = 0,
  relationshipLabel = '在一起',
  detailedTime = null,
  anniversaryDate = null,
  anniversaryType = 'couple',
  quote = ''
}) => {
  return (
    <div
      style={{
        width: '1080px', height: '1350px',
        background: 'linear-gradient(135deg, #f5e6d3 0%, #e8d4bf 50%, #f5e6d3 100%)',
        overflow: 'hidden', fontFamily: 'Arial, sans-serif',
        position: 'relative', boxSizing: 'border-box'
      }}
    >
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 3px, rgba(139, 69, 19, 0.015) 3px, rgba(139, 69, 19, 0.015) 6px), repeating-linear-gradient(90deg, transparent, transparent 3px, rgba(139, 69, 19, 0.015) 3px, rgba(139, 69, 19, 0.015) 6px)', opacity: 0.6 }} />

      <div style={{ position: 'relative', zIndex: 10, height: '100%', display: 'flex', flexDirection: 'column', padding: '70px 70px 60px 70px', boxSizing: 'border-box' }}>
        <div style={{ textAlign: 'center', marginBottom: '50px' }}>
          <div style={{ display: 'inline-block', padding: '25px', background: 'rgba(139, 69, 19, 0.05)', borderRadius: '50%', border: '2px solid rgba(139, 69, 19, 0.2)' }}>
            <svg width="140" height="140" viewBox="0 0 24 24" fill="none">
              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="#a67c52" opacity="0.7" />
            </svg>
          </div>
        </div>

        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center' }}>
          <div style={{ fontSize: '220px', fontWeight: '800', color: '#6d4c41', lineHeight: '1', marginBottom: '20px', fontFamily: 'Arial, sans-serif', letterSpacing: '0', opacity: 0.85 }}>{calculatedDays}</div>
          <div style={{ fontSize: '48px', fontWeight: '600', color: '#8d6e63', marginBottom: '40px', opacity: 0.8 }}>{language === 'zh' ? `${relationshipLabel}的日子` : `days ${relationshipLabel}`}</div>
          {detailedTime && (<div style={{ fontSize: '36px', color: '#6d4c41', fontWeight: '500', marginBottom: '30px', padding: '18px 45px', background: 'rgba(255, 255, 255, 0.4)', border: '2px solid rgba(139, 69, 19, 0.2)', borderRadius: '55px', display: 'inline-block' }}>{formatDetailedTime(detailedTime, language)}</div>)}

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '25px' }}>
            <div style={{ fontSize: '26px', opacity: 0.4, margin: '0 12px' }}>✿</div>
            <div style={{ width: '90px', height: '2px', background: 'linear-gradient(90deg, transparent, rgba(139, 69, 19, 0.3), transparent)' }} />
            <div style={{ fontSize: '32px', opacity: 0.5, margin: '0 14px' }}>❀</div>
            <div style={{ width: '90px', height: '2px', background: 'linear-gradient(90deg, transparent, rgba(139, 69, 19, 0.3), transparent)' }} />
            <div style={{ fontSize: '26px', opacity: 0.4, margin: '0 12px' }}>✿</div>
          </div>

          {quote && (<div style={{ fontSize: '30px', color: '#8d6e63', fontStyle: 'italic', lineHeight: '1.5', maxWidth: '750px', margin: '0 auto', opacity: 0.75 }}>"{quote}"</div>)}
        </div>

        <div style={{ textAlign: 'center', background: 'rgba(139, 69, 19, 0.05)', border: '2px double rgba(139, 69, 19, 0.2)', borderRadius: '14px', padding: '25px' }}>
          {anniversaryDate && (<div style={{ fontSize: '28px', color: '#8d6e63', marginBottom: '12px', opacity: 0.8 }}>{formatDate(anniversaryDate, language)}</div>)}
          <div style={{ fontSize: '34px', fontWeight: '700', color: '#a67c52', textTransform: 'uppercase', letterSpacing: '2.5px', marginBottom: '8px' }}>{getBrandingText(anniversaryType, language)}</div>
          <div style={{ fontSize: '24px', color: '#8d6e63', opacity: 0.7 }}>lovedays.homy.hk</div>
        </div>
      </div>
    </div>
  );
};

export default PaperTemplate;